<a
                href="{{url}}"
                target="_blank"
                class="fab fa-linkedin-in"></a>